import HeroLandingLoader from './versions/0.0.1/HeroLandingLoader';

export default HeroLandingLoader;
